import { Pipe, PipeTransform } from '@angular/core';
import {
  ADMIN_ROLE,
  CARER_ROLE,
  COORDINATOR_ROLE,
  CUSTOMER_CARER_ROLE,
  CUSTOMER_COORDINATOR_ROLE,
  CUSTOMER_FAMILY_REPRESENTATIVE_ROLE,
  CUSTOMER_FAMILY_ROLE,
  CUSTOMER_MEMBER_ROLE,
  CUSTOMER_SELF_ROLE,
  FAMILY_ROLE,
  ORGANISATION_ADMIN_ROLE,
} from '@careapp-group/core';
import { MemberFilterOptions } from '../member-filter/member-filter.component';
import { MemberDto } from '@careapp-group/ng-sdk';

/**
 * Member filter pipe
 * Takes a list of MemberDto, and filter options (MemberFilterOptions),
 * Will return a list where either family or staff have been filtered out, based on options.
 */
@Pipe({
    name: 'memberFilter',
    standalone: false
})
export class MemberFilterPipe implements PipeTransform {
  customerRoles = [CUSTOMER_SELF_ROLE, CUSTOMER_MEMBER_ROLE];
  familyRoles = [FAMILY_ROLE, CUSTOMER_FAMILY_ROLE, CUSTOMER_FAMILY_REPRESENTATIVE_ROLE];
  adminRoles = [ORGANISATION_ADMIN_ROLE, ADMIN_ROLE];
  coordinatorRoles = [CUSTOMER_COORDINATOR_ROLE, COORDINATOR_ROLE];
  teamMemberRoles = [CUSTOMER_CARER_ROLE, CARER_ROLE];

  public transform(team: MemberDto[], filter: MemberFilterOptions) {
    return team.filter((member) => {
      // Filter out limited results.
      if (!member?.firstName || member.firstName === '') {
        return false;
      }
      return member.permissions.some((permission) => {
        // Customers
        if (filter.customer && this.customerRoles.some((role) => role === permission.role)) {
          return true;
        }
        // Family
        if (filter.family && this.familyRoles.some((role) => role === permission.role)) {
          return true;
        }
        // Team member
        if (filter.teamMember && this.teamMemberRoles.some((role) => role === permission.role)) {
          return true;
        }
        // Coordinator
        if (filter.coordinator && this.coordinatorRoles.some((role) => role === permission.role)) {
          return true;
        }
        // Admins
        if (filter.admins && this.adminRoles.some((role) => role === permission.role)) {
          return true;
        }

        return false;
      });
    });
  }
}
